import { render, staticRenderFns } from "./TripResultItem.vue?vue&type=template&id=a54b4068&scoped=true"
import script from "./TripResultItem.vue?vue&type=script&lang=js"
export * from "./TripResultItem.vue?vue&type=script&lang=js"
import style0 from "./TripResultItem.vue?vue&type=style&index=0&id=a54b4068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54b4068",
  null
  
)

export default component.exports